module.exports = __webpack_public_path__ + "public/5feb23cc4ed371f32c5aa395f7bd5867.woff2";